import React from 'react';
import Plot from 'react-plotly.js';
import { handleRelayout } from './utils';
import './MapPlot.css';



export function MapPlot({ mapData, mapCenter, zoomLevel, colorBarRange, updateMapView, mapboxStyle, colorscalePalette, isSelecting, onPolygonSelect }) {

    const plotData = {
        type: 'scattermapbox',
        mode: 'markers',
        marker: {
            size: 10,
            color: mapData.map(d => d.price),
            cmin: colorBarRange[0], // Keep original color bar min
            cmax: colorBarRange[1], // Keep original color bar max
            colorscale:
            colorscalePalette,
            colorbar: {
                title: 'Price (£)',
                x: 0.025,
                xanchor: 'left',
                xpad: 0,
                y: 0.82,
                yanchor: 'middle',
                ypad: 0,
                thickness: 10,
                len: 0.3,
                outlinecolor: 'black',
                outlinewidth: 1,
                tickfont: {
                    size: 10,
                    color: 'black'
                },
                // give it semi transparent background
                bgcolor: 'rgba(255, 255, 255, 0.8)',
                // set the ticks on a 100k interval
                tickmode: 'array',
                // mark each 100k
                tickvals: { start: Math.floor(colorBarRange[0] / 100000) * 100000, end: Math.ceil(colorBarRange[1] / 100000) * 100000, size: 100000}
            }
        },
        lat: mapData.map(d => d.latitude),
        lon: mapData.map(d => d.longitude),
        text: mapData.map(d => `Price: £${d.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}<br>Date: ${d.month_year}<br>Type: ${d.type}<br>Postcode: ${d.post_code}<br>Address: ${d.address}`),
        hoverinfo: 'text',
    };

    const plotLayout = {
        autosize: true,
        hovermode: 'closest',
        dragmode: isSelecting ? 'lasso' : 'pan',
        mapbox: {
            style: mapboxStyle || 'open-street-map',
            center: mapCenter,
            zoom: zoomLevel,
        },
        margin: {
            l: 0,
            r: 0,
            b: 0,
            t: 0,
            pad: 4
        }
    };

    const plotStyle = {
        width: '100%',
        height: '100vh',
    };

    const plotConfig = {
        displayModeBar: false,
        scrollZoom: !isSelecting
    };

    const handleSelect = (eventData) => {
        if (eventData && eventData.points && eventData.points.length > 0 && isSelecting) {
            // Get the selected points
            const selectedIndices = eventData.points.map(point => point.pointIndex);
            const selectedData = selectedIndices.map(index => mapData[index]);
            
            if (selectedData.length > 0 && onPolygonSelect) {
                // Create a bounding polygon from selected points
                const lats = selectedData.map(d => d.latitude);
                const lons = selectedData.map(d => d.longitude);
                const minLat = Math.min(...lats);
                const maxLat = Math.max(...lats);
                const minLon = Math.min(...lons);
                const maxLon = Math.max(...lons);
                
                // Create a simple rectangular polygon for filtering
                const polygonPoints = [
                    [minLon, minLat],
                    [maxLon, minLat],
                    [maxLon, maxLat],
                    [minLon, maxLat],
                    [minLon, minLat]
                ];
                
                onPolygonSelect(polygonPoints);
            }
        }
    };




    return (
        <div style={{ position: 'relative', touchAction: 'none' }}>
            <Plot
                data={[plotData]} 
                layout={plotLayout}
                style={plotStyle}
                config={plotConfig}
                onRelayout={handleRelayout(updateMapView)}
                onSelected={handleSelect}
            />
        </div>
    );
}